"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icos_cp_backend_1 = require("icos-cp-backend");
class StationFilter {
    constructor(toggleLayers, filterFn, countryLookup) {
        this.stationsToFilter = toggleLayers.filter(tl => tl.geoType === 'point' || tl.id === 'ship');
        this.stationNames = this.stationsToFilter.map(themeStations => themeStations.label);
        this.filterFn = filterFn;
        this.countryList = countryLookup
            ? this.getCountryList(countryLookup)
            : [];
        this.selectedCountry = "0";
        this.showNonLabelledStations = true;
    }
    getCountryList(countryLookup) {
        const iso2Filtered = this.stationsToFilter.reduce((acc, theme) => {
            const stations = theme.data;
            if (Array.isArray(stations)) {
                stations.forEach(station => acc.add(station.attributes[icos_cp_backend_1.Vars.country]));
            }
            else {
                stations.features.forEach(feature => {
                    if (feature.properties)
                        acc.add(feature.properties[icos_cp_backend_1.Vars.country]);
                });
            }
            return acc;
        }, new Set());
        return Array.from(iso2Filtered).map((code) => {
            const name = countryLookup[code].length > 20
                ? countryLookup[code].slice(0, 19) + '...'
                : countryLookup[code];
            return {
                val: code,
                name
            };
        }).sort((a, b) => a.name < b.name ? -1 : 1);
    }
}
exports.default = StationFilter;
